import { Logger } from '@life-time-inc/enterprise-framework-core';

export const logger = new Logger({
	service: 'enterprise-framework',
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	version: import.meta.env.VITE_APP_VERSION
});
